module.exports = __webpack_public_path__ + "img/orangeBar.b02dc1bb.svg";